const runtimeConfig = typeof window !== "undefined" ? window.__ENV__ || {} : {};
const buildEnv = typeof process !== "undefined" && process?.env ? process.env : {};

const isRuntimePlaceholder = (value = "") =>
  typeof value === "string" && /^__.+__$/.test(value);

const pickValidConfigValue = (...values) =>
  values.find((value) => value && !isRuntimePlaceholder(value));

export const getTrackingApiUrl = () => {
  const value =
    pickValidConfigValue(
      runtimeConfig.TRACKING_API_URL,
      buildEnv.REACT_APP_TRACKING_API_URL
    ) || "";

  return String(value || "").replace(/\/$/, "");
};

export const getTrackingSchemaVersion = () => {
  const value =
    pickValidConfigValue(
      runtimeConfig.TRACKING_SCHEMA_VERSION,
      buildEnv.REACT_APP_TRACKING_SCHEMA_VERSION
    ) || "1.0";

  return String(value).trim() || "1.0";
};
